import CorporateLayout from './NotificationLayout';

export default CorporateLayout;
